module.exports = __webpack_public_path__ + "static/media/mmf_pausenanimation_small_004.4c5babd0.png";